import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import { removeQuoteConcept } from "../apis/removeQuoteConcept";

export const useRemoveQuoteConcept = () => {
    const queryClient = useQueryClient();

    return useMutation<ApiResponse, Error, number>({
        mutationFn: removeQuoteConcept,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
        },
    });
};
